export default "__VITE_ASSET__630b5d8a__"